import { useState, useEffect } from 'react'
import { db } from '../firebase/config'

/**
 * Leest de uitkomst van de nachtelijke controle (IntelligenceSweeps/current).
 *
 * `neverRan` is een eigen toestand, geen afgeleide van een lege lijst. Een
 * controle die nooit gedraaid heeft levert nul driftmeldingen en een leeg
 * signaleringslijstje op — precies hetzelfde beeld als "alles in orde". Het
 * overzicht moet die twee uit elkaar kunnen houden.
 *
 * AI-CONTEXT: See docs/pitfalls.md#dev-one-off-step-has-no-red-test
 * AI-CONTEXT: See docs/features/intelligence-research-questions.md (§8)
 *
 * @returns {{sweep: (object|null), neverRan: boolean, loading: boolean, loaded: boolean, error: (Error|null)}}
 */
const useIntelligenceSweep = () => {
    const [sweep, setSweep] = useState(/** @type {object|null} */(null))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        setLoaded(false)
        setError(null)

        const unsub = db.collection('IntelligenceSweeps').doc('current').onSnapshot(
            (snap) => {
                setSweep(snap.exists ? snap.data() : null)
                setLoaded(true)
            },
            (err) => {
                console.error('useIntelligenceSweep:', err)
                setError(err)
                setSweep(null)
                setLoaded(false)
            },
        )
        return () => unsub()
    }, [])

    return {
        sweep,
        // Alleen waar als we het ZEKER weten: nog niet geladen betekent niet
        // "nooit gedraaid".
        neverRan: loaded && sweep === null,
        loading: !loaded && !error,
        loaded,
        error,
    }
}

export default useIntelligenceSweep
